import { Domain } from '@trashlab/api/src/domains/core/types';

export type InvalidateArgs = Domain | { path: string } | { domain: Domain };

export function invalidationPredicate(
  params: string | { path: string } | { domain: Domain },
) {
  return ({ queryKey }: { queryKey: unknown }) => {
    const [key, opts] = queryKey as [string[], { type: string; input: any }];

    if (!key?.join) {
      return false;
    }

    const joined = Array.from(key).join('.');
    // No-superjson queries are cached under an 'ns.' key prefix while their logical
    // path (what domain/path invalidations are written against) is unprefixed. Match
    // against the normalized path so `invalidate('identity')` etc. still hit them.
    const normalized = joined.startsWith('ns.') ? joined.slice('ns.'.length) : joined;
    if (typeof params === 'string') {
      return normalized.startsWith(params);
    }
    if ('path' in params) {
      return normalized === params.path;
    }

    return normalized.startsWith(params.domain);
  };
}
